/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-shadow */
import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, QueryList, ViewChildren } from '@angular/core';

import { Observable, of, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MessageService } from 'primeng/api';

import { InfluencerStreamApiModel } from '../../../../../api/targeting/model/influencer-stream.api.model';
import { TargetingSearchesApiService } from '../../../../../api/targeting/targeting-searches.api.service';
import { ContactsPublicApi } from '../../../../../api/targeting/contacts-public.api';
import { OutletsPublicApi } from '../../../../../api/targeting/outlets-public.api';

import { Mention } from '../../../../../Common/Mentions/models/mention';

import { messageSeverityEnum } from '../../../../../Common/Misc/enums/message-severity.enum';
import { ButtonTypesEnum } from '../../../../../Common/Forms/enums/button-types.enum';
import { FilterService } from '../../../../../Common/Filter/services/abstract-filter.service';
import { DropdownOptionModel } from '../../../../../Common/Forms/models/dropdown-option.model';
import { ConfirmDialogComponent } from '../../../../../Common/Dialogs/components/ConfirmDialog/confirm-dialog.component';
import { ConfirmDialogModel } from '../../../../../Common/Dialogs/models/confirm-dialog.model';
import { FilterGroupModel } from '../../../../../Common/Filter/models/filter-group.model';
import { RelativeTimePipe } from '../../../../../Common/Misc/pipes/RelativeTime/relative-time.pipe';
import { TargetingFiltersEnum } from '../../../../../Common/TargetingShared/enum/targeting-filters.enum';
import { TargetingPreferencesService } from '../../../../../Common/TargetingShared/services/targeting-preferences.service';
import { EntityTypeDefaultImageEnum } from '../../../../../Common/Misc/enums/entity-type-default-image.enum';
import { KeywordHighlightModel } from '../../../../../Common/Misc/models/keyword-highlight.model';

import { LocalizationService } from '../../../../../Core/Localization/services/localization.service';
import { CoreDialogService } from '../../../../../Core/Dialogs/services/dialog.service';
import { userPermissionsEnum } from '../../../../../Core/Users/enums/user-permissions.enum';
import { CurrentUserStateService } from '../../../../../Core/Users/services/current-user-state.service';

import { TargetingSearchesService } from '../../../services/targeting-searches.service';
import { TargetingListService } from '../../../services/targeting-list.service';
import { TargetingSearchService } from '../../../services/targeting-search.service';
import { TargetingSearchList } from '../../../models/targeting-search-list.model';
import { TargetingListList } from '../../../models/targeting-list-list.model';
import { TargetingSearch } from '../../../models/targeting-search.model';
import { JournodexEntityFactory } from '../../../factories/journodex-entity.factory';

import { SourceType } from '../../../services/source-picker-service';
import { ManageListDialogComponent } from '../../TargetingResults/ManageListDialog/manage-list-dialog.component';

import { InfluencerStreamsService } from '../influencer-streams-service';
import { StreamSourcePickerService } from './stream-source-picker-service';
import { ReachFilterModel } from '../../../../../Common/TargetingShared/model/reach-filter.model';
import { SearchModeEnum } from '../../../../../Common/TargetingShared/enum/search-mode.enum';
import { ActionKeys } from '../../../../../Common/Forms/enums/keys.enum';
import { MediaTypeEnum } from '@Common/Basic/enums/media-type.enum';

export interface MentionSelectedEvent {
    mention: Mention;
    openOutletTab: boolean;
    visibleStreamMentions: Mention[];
    streamId: number;
}
@Component({
    selector: 'agpr-influencer-stream',
    templateUrl: './influencer-stream.component.html',
    styleUrls: ['../../../../../Common/TargetingShared/components/ResultCard/result-card.scss', './influencer-stream.component.scss'],
    providers: [
        StreamSourcePickerService,
        {
            provide: FilterService,
            useExisting: StreamSourcePickerService
        }
    ],
    standalone: false
})
export class InfluencerStreamComponent implements OnDestroy, AfterViewInit, AfterViewChecked {

    _stream: InfluencerStreamApiModel;
    @Input() set stream(stream: InfluencerStreamApiModel) {
        this._stream = stream;
        this.setStreamContentFilter();
        this.setSelectedSearch();
        this.setSelectedList();

        if (stream && !stream.id) {
            this._stream.editing = true;
            this.sourcePickerService.changeToKeywordStreamMode();
        }

        if (stream.keyphrase) {
            this.sourcePickerService.changeToKeywordStreamMode();
        }
    }

    @Input() index: number;
    @Input() streamsLength: number;

    @Output() mentionSelected: EventEmitter<MentionSelectedEvent> = new EventEmitter<MentionSelectedEvent>();
    @Output() deletedIndex: EventEmitter<number> = new EventEmitter<number>();
    @Output() skipCurrentStream: EventEmitter<number> = new EventEmitter<number>();
    @Output() streamLoading: EventEmitter<boolean> = new EventEmitter<boolean>(false);

    @ViewChildren('mentionsList') mentionsList: QueryList<ElementRef>;


    sourceTypes: DropdownOptionModel[] = [
        {
            label: 'Discover.influencerStreams.sourceType.savedSearch',
            value: SourceType.searches
        },
        {
            label: 'Discover.recipientEditor.labels.lists',
            value: SourceType.lists
        },
        {
            label: 'Discover.influencerStreams.keyword',
            value: 'keyword'
        }
    ];

    sources$: Observable<TargetingSearchList[] | TargetingListList[]>;
    selectedSource: TargetingSearchList | TargetingListList;

    selectedSourceType: DropdownOptionModel = this.sourceTypes[2];

    subscriptions: Subscription[] = [];
    searches: TargetingSearchList[];
    lists: TargetingListList[];

    userHasMonitoring: boolean = false;
    mentionLinksEnabled: boolean;

    chipsVisible = false;

    streamSettings;
    selectedStreamSetting;

    sidebarExpanded;
    rhpTakeOver;

    visibleMentions: Mention[];
    hiddenMentions: Mention[] = [];
    lastFetch = null;
    lastStart = 0;

    loading = false;
    nextFetch;

    focusedMention: Mention;

    sourceSelectorPlaceholder: string = 'Discover.influencerStreams.sourceSelection.keyword.placeholder';
    keywords: KeywordHighlightModel[] = [];

    listSizeLimit: number = 1000;
    showWarningMessage: boolean = null;

    relativeTimePipe: RelativeTimePipe;
    imageDefault = EntityTypeDefaultImageEnum;

    totalMentions: number;

    isFilterQueryPopulated: boolean = false;

    focusableElements: HTMLElement[] = [];

    readonly messageSeverities = messageSeverityEnum;
    readonly buttonTypes = ButtonTypesEnum;
    readonly sourceTypeEnum = SourceType;
    readonly mediaTypeEnum = MediaTypeEnum;

    constructor(
        public messageService: MessageService,
        public localizationService: LocalizationService,
        public influencerStreamsService: InfluencerStreamsService,
        public targetingSearchesService: TargetingSearchesService,
        public targetingListService: TargetingListService,
        public sourcePickerService: StreamSourcePickerService,
        public coreDialogService: CoreDialogService,
        public targetingSearchService: TargetingSearchService,
        public targetingSearchesApiService: TargetingSearchesApiService,
        public contactsApi: ContactsPublicApi,
        private currentUserService: CurrentUserStateService,
        private targetingPreferencesService: TargetingPreferencesService,
        private filterService: FilterService,
        private journodexEntityFactory: JournodexEntityFactory,
        private cd: ChangeDetectorRef,
        public outletsApi: OutletsPublicApi,
        private el: ElementRef
    ) {
        this.subscriptions.push(
            this.targetingSearchesService.all$.pipe(filter(x => !!x)).subscribe(x => {
                if (!this.searches) {
                    this.searches = x;
                    this.searches.sort((a, b) => a.name.localeCompare(b.name));
                    this.setSelectedSearch();
                }
            }),
            this.targetingListService.all$.pipe(filter(x => !!x)).subscribe(lists => {
                if (!this.lists) {
                    this.lists = lists;
                    this.setSelectedList();
                }
            }),
            this.sourcePickerService.getFilters().subscribe(filters => {
                this.chipsVisible = !!filters.find(filter => {
                    if (filter instanceof FilterGroupModel) {
                        return filter.children.find(x => x.chips && x.chips.length > 0);
                    } else if (filter instanceof ReachFilterModel) {
                        return filter.hasValueSet();
                    } else {
                        return filter.chips && filter.chips.length > 0;
                    }
                });
                if (this._stream) {
                    if (this._stream.filterQuery && !this.isFilterQueryPopulated) {
                        this.sourcePickerService.populateFiltersFromSearch(new TargetingSearch({ query : this._stream.filterQuery}));
                        this.isFilterQueryPopulated = true;
                    }
                    this._stream.mentionMediaTypes = filters.find(filter => filter.id === TargetingFiltersEnum.streamContent)?.getValue().map(value => value.id);
                }
            }),
            this.influencerStreamsService.focusedMentionProvider.subscribe(x => this.focusedMention = x),
            this.sourcePickerService.getItemCount().subscribe(
                total => {
                    if (total === null) {
                        return;
                    }
                    this.showWarningMessage = total > this.listSizeLimit - 1;
                    this.fetchMentions();
                }
            ),
            this.currentUserService.getPermissions().subscribe(permissions => {
                this.userHasMonitoring = !!permissions?.find(x => x === userPermissionsEnum.advancedMonitoring);
            }),
            this.targetingPreferencesService.mentionLinksEnabled$.subscribe(enabled => {
                this.mentionLinksEnabled = enabled;
            })
        );
        this.relativeTimePipe = new RelativeTimePipe(this.localizationService);
    }


    setSelectedSearch() {
        if (this._stream && this._stream.searchId && this.searches) {
            this.selectedSourceType = this.sourceTypes.find(x => x.value === SourceType.searches);
            this.sourceTypeChanged(false);
            this.selectedSource = this.searches.find(x => x.id === this._stream.searchId);
            this.sourcePickerService.setActiveSearch(this.selectedSource);
        }
    }

    setSelectedList() {
        if (this._stream && this._stream.listId && this.lists) {
            this.selectedSourceType = this.sourceTypes.find(x => x.value === SourceType.lists);
            this.sourceTypeChanged(false);
            this.selectedSource = this.lists.find(x => x.id === this._stream.listId);
            this.sourcePickerService.setActiveList(this.selectedSource);
        }
    }

    setStreamContentFilter() {
        this.sourcePickerService.setStreamContentFilter(this._stream.mentionMediaTypes);
    }

    ngOnDestroy() {
        this.subscriptions.forEach(x => x.unsubscribe());
        clearTimeout(this.nextFetch);
    }

    ngAfterViewInit() {
        this.showWarningMessage = null;
        if (this._stream.id) {
            this.fetchMentions();
        }
        this.focusableElements = this.el.nativeElement.querySelectorAll('button, [href], input, [tabindex="0"]');
    }

    ngAfterViewChecked(){
        this.cd.detectChanges();
    }

    sourceTypeChanged(clearFilters: boolean = true) {
        if (!this.selectedSourceType) {
            return;
        }
        this.showWarningMessage = false;
        if (this.selectedSourceType.value === SourceType.searches) {
            this.sourceSelectorPlaceholder = 'Discover.influencerStreams.sourceSelection.search.placeholder';

            this.sources$ = of(this.searches);

            if (clearFilters) {
                this._stream.keyphrase = null;
                this._stream.listId = null;
                this.selectedSource = null;
                this.sourcePickerService.clearSearch();
                this.sourcePickerService.leaveKeywordStreamMode();
                this.checkSelectedSource();
            }
        } else if (this.selectedSourceType.value === SourceType.lists) {
            this.sourceSelectorPlaceholder = 'Discover.influencerStreams.sourceSelection.list.placeholder';

            this.sources$ = of(this.lists);

            if (clearFilters) {
                this._stream.keyphrase = null;
                this._stream.searchId = null;
                this.selectedSource = null;
                this.sourcePickerService.clearSearch();
                this.sourcePickerService.leaveKeywordStreamMode();
                this.checkSelectedSource();
            }

        } else {
            // keyphrase
            this.sourceSelectorPlaceholder = 'Discover.influencerStreams.sourceSelection.keyword.placeholder';

            if (clearFilters) {
                this._stream.searchId = null;
                this._stream.listId = null;
                this.selectedSource = null;
                this.sourcePickerService.clearSearch();
                this.sourcePickerService.changeToKeywordStreamMode();
            }
        }
    }

    sourceChanged(event?: TargetingSearchList | TargetingListList) {
        this.selectedSource = event;
        if (this.selectedSource instanceof TargetingSearchList) {
            this._stream.searchId = this.selectedSource.id;
            this._stream.listId = null;
            this.sourcePickerService.setActiveSearch(this.selectedSource);
        } else if (this.selectedSource instanceof TargetingListList) {
            this._stream.listId = this.selectedSource.id;
            this._stream.searchId = null;
            this.sourcePickerService.setActiveList(this.selectedSource);
        }
        this.checkSelectedSource();
    }

    apply() {
        if (this._stream.keyphrase || this._stream.searchId || this._stream.listId) {
            this.loading = true;
            this.streamLoading.emit(this.loading);
            this.lastFetch = null;
            this._stream.filterQuery = this.sourcePickerService.generateFiltersSearch().toApiModel().query;
            if (this._stream.filterQuery.outletIdNamePair.include.length > 0) {
                this._stream.filterQuery.searchMode = SearchModeEnum.outlet;
            }
            this.influencerStreamsService.saveStream(this.index).then(x => {
                this.visibleMentions = [];
                this.hiddenMentions = [];

                if (!this.selectedSource) {
                    this.fetchMentions();
                }
                if (this.selectedSource instanceof TargetingSearchList) {
                    this.sourcePickerService.setActiveSearch(this.selectedSource);
                } else if (this.selectedSource instanceof TargetingListList) {
                    this.sourcePickerService.setActiveList(this.selectedSource);
                }
            });
        } else {
            this.influencerStreamsService.deleteStream(this.index);
        }
        this._stream.editing = false;
    }

    closeToolbar() {
        if (this._stream.keyphrase || this._stream.searchId || this._stream.listId) {
            // nothing to save
        } else {
            this.influencerStreamsService.deleteStream(this.index);
        }
        this._stream.editing = false;
    }

    fetchMentions(): void {
        // TODO : Adjust interval depending on number of results?
        clearTimeout(this.nextFetch);

        if (!this.showWarningMessage) {
            this.nextFetch = setTimeout(() => {
                this.fetchMentions();
            }, 60 * 1000);
        }

        /**
         * If stream source is search or list and:
         * showWarningMessage = null -> prevent it from getting content while limit is still being calculated
         * (happens when this gets called by ngAfterViewInit)
         * showWarningMessage = true -> no need to get content
         *
         * Second case is if the stream isn't saved yet and we're just running the search to fetch filter info
         */
        if (
            (
                (this._stream.searchId || this._stream.listId) &&
                this.showWarningMessage !== false
            ) ||
            !this._stream?.id
        ) {
            this.loading = false;
            this.streamLoading.emit(this.loading);
            return;
        }

        if (!this.lastFetch) {
            this.loading = true;
            this.streamLoading.emit(this.loading);
            this.cd.detectChanges();
        };

        // need to set a variable lastFetch..
        // because whats happening here is at the time of the get, this.lastFetch is null
        // but when getStreamContent returns, sometimes the this.lastFetch is set elsewhere and therefore setting hiddenMentions when there isn't any
        const lastFetch = this.lastFetch;

        this.influencerStreamsService.getStreamContent(this.index, lastFetch, 0).subscribe({
            next: (response) => {
                this.totalMentions = response.totalResults;

                const mentions = response.mentions.map(x => new Mention(x));

                this.influencerStreamsService.applyTwitterInfo(mentions);
                if (!lastFetch) {
                    this.visibleMentions = mentions;
                    this.visibleMentions?.forEach(x => x.imagesExpanded = this._stream.showImages);
                } else {
                    this.hiddenMentions = [...mentions, ...this.hiddenMentions];
                }
                if (this._stream.keyphrase) {
                    this.keywords = [];
                    const words = this.splitKeyphrase(this._stream.keyphrase);
                    words.forEach(word => {
                        const keyword: KeywordHighlightModel = {
                            keywords: [word],
                            caseSensitive: false,
                            class: 'agpr-highlight'
                        };
                        this.keywords.push(keyword);
                    });
                }

                this.loading = false;
                this.streamLoading.emit(this.loading);
                if (this.hiddenMentions && this.hiddenMentions.length > 0) {
                    this.lastFetch = new Date(this.hiddenMentions[0].dateAvailable.getTime() + 1000);
                } else if (this.visibleMentions && this.visibleMentions.length > 0) {
                    this.lastFetch = new Date(this.visibleMentions[0].dateAvailable.getTime() + 1000);
                }
                this.updateRelativeTime();
            },
            error: () => {
                this.loading = false;
                this.streamLoading.emit(this.loading);
            }
        });
    }

    // Fetched when scrolled to the bottom
    fetchOlderMentions() {
        // Reached the end
        if (this.totalMentions === this.visibleMentions.length + this.hiddenMentions.length) {
            return;
        }

        this.loading = true;
        this.streamLoading.emit(this.loading);
        this.influencerStreamsService.getStreamContent(this.index, null, this.visibleMentions.length + this.hiddenMentions.length).subscribe(response => {
            this.totalMentions = response.totalResults;
            const newMentions = [];
            for (const mention of response.mentions) {
                // Due to the blocky pagination system we may receive stuff that was already shown
                if (this.visibleMentions.findIndex(x => x.id === mention.mercuryId) >= 0) {
                    continue;
                }
                newMentions.push(new Mention(mention));
            }
            this.influencerStreamsService.applyTwitterInfo(newMentions);
            newMentions.forEach(x => x.imagesExpanded = this._stream.showImages);
            this.visibleMentions = [...this.visibleMentions, ...newMentions];
            this.updateRelativeTime();
            if (this.influencerStreamsService.isFocusedStream(this._stream?.id)) {
                const contactUuids = this.visibleMentions.map(mention => {
                    return mention.author.uuid;
                });
                this.influencerStreamsService.searchStreamContacts(contactUuids);
            }
            this.loading = false;
            this.streamLoading.emit(this.loading);
        });
    }

    revealMentions() {
        this.hiddenMentions.forEach(x => x.imagesExpanded = this._stream.showImages);
        this.visibleMentions = [...this.hiddenMentions, ...this.visibleMentions];

        this.hiddenMentions.length = 0;
        this.updateRelativeTime();
    }

    toggleImageExpansion() {
        this._stream.showImages = !this._stream.showImages;
        this.visibleMentions?.forEach(x => x.imagesExpanded = this._stream.showImages);
    }

    keywordInputKeydown(event: KeyboardEvent) {
        switch (event.key) {
            case 'Enter' :
                this.apply();
                break;
        }
    }

    resetStream() {
        const confirmDialogModel: ConfirmDialogModel = {
            inputs: {
                heading: 'Discover.influencerStreams.resetDialog.heading',
                message: 'Discover.influencerStreams.resetDialog.message',
                okLabel: 'Discover.influencerStreams.resetDialog.okButton',
                showCancel: true
            },
            outputs: {
                dialogClose: (confirmed: boolean) => {
                    if (confirmed) {
                        const hideOutletContactTabs = !!this.visibleMentions?.find(x => x.id === this.focusedMention.id);
                        if (hideOutletContactTabs) {
                            this.influencerStreamsService.setFocusedMention(null);
                            // Try to focus the first mention of any streams when deleting the stream of the current focused mention.
                            this.deletedIndex.emit(this.index);
                        }
                        this.influencerStreamsService.deleteStream(this.index, hideOutletContactTabs);
                    }
                }
            }
        };
        this.coreDialogService.open(ConfirmDialogComponent, confirmDialogModel);
    }

    focusFirstMention(): void {
        if (this.visibleMentions) {
            const contactUuids = this.visibleMentions.map(mention => {
                return mention.author.uuid;
            });
            this.influencerStreamsService.setFocusedMention(this.visibleMentions[0], false, contactUuids, this._stream.id);
        }
    }

    openManageListDialog(mention: Mention) {
        this.contactsApi.getContact(mention.author.uuid).subscribe(async contact => {
            this.coreDialogService.open(ManageListDialogComponent, {
                inputs: {
                    setEntity: await this.journodexEntityFactory.createContact(contact)
                },
                outputs: {
                }
            });
        });
    }

    updateRelativeTime(): void {
        this.visibleMentions?.forEach(mention => {
            mention.relativeDateString = this.relativeTimePipe.transform(mention.dateAvailable);
        });
    }
    checkSelectedSource(){
        if (!this.selectedSource){
            this.filterService.clearFilters();
        }
    }

    unlockMentionClicked(mentions: Mention[]) {
        this.influencerStreamsService.refetchMentions(mentions.map(m => m.id), false, true).subscribe(
            response => {
                mentions.forEach(m => {
                    this.visibleMentions.find(visibleMention => visibleMention.id === m.id).url = response[m.id].url;
                });
            }
        );
    }

    /**
     * Separates out single words from phrases surrounded by quotes, and returns an array of both sets.
     * @param keyphrase A string containing single words, or phrases surrounded by quotes
     * @returns An array containing each separated single word, and each phrase (without the quotes)
     */
    private splitKeyphrase(keyphrase: string): string[] {
        const phrasesWithQuotesRegex = /"[^"]+"/g;
        const phrasesWithQuotes = keyphrase.match(phrasesWithQuotesRegex);
        if (!phrasesWithQuotes) {
            return keyphrase.split(' ');
        }

        const replaceQuotedWordsRegex = new RegExp(phrasesWithQuotes.join('|'), 'g');
        const singleWordsNoExtraSpaces = keyphrase
            .replace(replaceQuotedWordsRegex, '')
            .split(' ')
            .filter(word => word.length > 0);
        const phrasesNoQuotes = phrasesWithQuotes.map(phrase => phrase.replace(/"/g, ''));
        return [...singleWordsNoExtraSpaces, ...phrasesNoQuotes];
    }

    selectMention(mention: Mention, openOutletTab: boolean) {
        const event: MentionSelectedEvent = {
            mention: mention,
            openOutletTab: openOutletTab,
            visibleStreamMentions: this.visibleMentions,
            streamId: this._stream.id
        };
        this.mentionSelected.emit(event);
    }
    onKeydown(event: KeyboardEvent) {
        if (!this.visibleMentions || this.visibleMentions.length === null) {
            return;
        }
        let focusedItem = null;
        let focusedItemIndex = null;
        if (event.target instanceof HTMLElement) {
            focusedItem = (event.target as HTMLElement).matches('article') ? event.target : event.target.closest('article');
            if (!focusedItem) {
                return;
            }
            focusedItemIndex = focusedItem.getAttribute('aria-posinset');
        }

        switch (event.key) {
            case ActionKeys.PAGEUP:
                // Move up focus
                event.preventDefault();
                if (focusedItemIndex > 1) {
                    // Need to increment by 2 because focusedItemIndex is 1-indexed
                    this.mentionsList.toArray()[focusedItemIndex - 2]?.nativeElement.focus();
                }
                break;
            case ActionKeys.PAGEDOWN:
                // Move down focus
                event.preventDefault();
                if (this.visibleMentions.length >= focusedItemIndex) {
                    // Do not need to increment focusedItemIndex because it is 1-indexed
                    this.mentionsList.toArray()[focusedItemIndex]?.nativeElement.focus();
                }
                break;
            case ActionKeys.HOME:
                // Move focus to the first focusable element before the feed
                if (event.ctrlKey && this.visibleMentions.length > 0) {
                    event.preventDefault();
                    this.focusableElements[0]?.focus();
                }
                break;
            case ActionKeys.END:
                // Skip current feed to the next one
                if (event.ctrlKey) {
                    event.preventDefault();
                    this.skipCurrentStream.emit(this.index);
                }
                break;
        }
    }
}
